import { render } from "./PhoneCallConfirm.vue?vue&type=template&id=13ceda17"
import script from "./PhoneCallConfirm.vue?vue&type=script&lang=js"
export * from "./PhoneCallConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2367962886/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__